import { render } from "./PersonalPlanList.vue?vue&type=template&id=1bfd77d2&scoped=true"
import script from "./PersonalPlanList.vue?vue&type=script&lang=js"
export * from "./PersonalPlanList.vue?vue&type=script&lang=js"

import "./PersonalPlanList.vue?vue&type=style&index=0&id=1bfd77d2&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bfd77d2"]])

export default __exports__